module.exports = __webpack_public_path__ + "media/images/dash_bkground-cd2c2d5dd54f58b9a1c1d4b039195678.png";